import { SafeLogErrorOptions } from '../log-error';
import { BaseError } from './BaseError';

export class JvbError extends BaseError {
    constructor(message: string, loggerFields: SafeLogErrorOptions, stack?: string) {
        super(
            message,
            {
                source: 'backend',
                block: 'jvb-session',
                ...loggerFields,
            },
            stack
        );

        Object.setPrototypeOf(this, JvbError.prototype);
    }
}
